import request from 'request-promise';

const fetchAndParse = async (componentName) =>
{
	try
	{
		const html = await request.postURL('/components/' + componentName);
		
		const parser = new DOMParser();
		const document = parser.parseFromString(html, 'text/html');
		
		const head = document.head;
		const template = head.querySelector('template');
		const style = head.querySelector('style');
		const script = head.querySelector('script');
		
		const componentParts =
		{
			template,
			style,
			script
		};
		
		return componentParts;
	}
	catch(error)
	{
		console.error(error);
		
		return error;
	}
};

const getSettings = async ({ template, style, script }) =>
{// 2022-11-17
    const baseUrl = new URL(import.meta.url).origin; // Get the base URL
    const processedScript = script.textContent.replace(
        /from '\/resources\/compiled\/js\/(.*?)\.js'/g, 
        `from '${baseUrl}/resources/compiled/js/$1.js'`
    );

    // console.log(processedScript);

    const jsFile = new Blob([processedScript], { type: 'application/javascript' });
    const jsURL = URL.createObjectURL(jsFile);
	
	const module = await import(jsURL)
	
	const settings =
	{
		ComponentClass: module.default,
		template: template,
		style: style
	};
	
	return settings;
};

const registerComponent = ({ template, style, name, ComponentClass }) =>
{// 2022-11-17
	// 2023-05-23 https://developer.chrome.com/articles/declarative-shadow-dom/#building-a-declarative-shadow-root
	class UnityComponent extends ComponentClass
	{
		constructor()
		{
			super();
			
			if(template && template.content)
			{
				const shadow = this.attachShadow({ mode: 'open' });
				
				shadow.appendChild(style.cloneNode(true));
				shadow.appendChild(document.importNode(template.content, true));
			}
			
			super.setup();
		}
	}
	
	const options = {};
	if(UnityComponent.getElementType !== undefined) options.is = UnityComponent.getElementType();
	if(UnityComponent.extends !== undefined) options.extends = UnityComponent.extends();
	
	const customElement = customElements.get(name);
	
	if(!!customElement)
	{
		console.warn('Component "'+name+'" is already registered. Use upgradeComponent if you wish to update the definition');
		return;
	}
	
	customElements.define(name, UnityComponent, options);
};

const loadComponent = async (componentName) =>
{// 2022-11-17
	const customElement = customElements.get(componentName);
	
	if(!!customElement)
	{
		console.warn('Component "'+componentName+'" is already registered. Use upgradeComponent if you wish to update the definition');
		return;
	}
	
	const componentParts = await fetchAndParse(componentName);
	
	const settings = await getSettings(componentParts);
	
	settings.name = componentName;
	
	registerComponent(settings);
};

export { registerComponent, loadComponent, getSettings };
export default loadComponent;
